import EditableTitle from "./EditableTitle";

export default EditableTitle;
